import { IText, Rect, Circle, Shadow, Textbox } from "fabric";

// Starter layouts in Glamour colours. Each returns { preset, objects } built fresh.
const NAVY = "#1f4e86", SKY = "#21a6ec", GREEN = "#8bc34a", PURPLE = "#7b3fc4", DARK = "#222736";
const sh = () => new Shadow({ color: "rgba(0,0,0,0.4)", blur: 6, offsetX: 2, offsetY: 2 });
const T = (text, o) => new IText(text, { fontFamily: "Montserrat", fontWeight: 900, fill: "#ffffff", strokeWidth: 0, ...o });
const B = (text, o) => new Textbox(text, { fontFamily: "Arial", fontSize: 14, fill: "#ffffff", strokeWidth: 0, ...o });
const R = (o) => new Rect({ strokeWidth: 0, ...o });
const photo = (o) => R({ fill: "rgba(255,255,255,0.18)", stroke: "#ffffff", strokeWidth: 2, strokeDashArray: [8, 6], rx: 12, ry: 12, ...o });

export const TEMPLATES = [
  { key: "banner_summer", label: "Footer Banner — Summer Ready", preset: "banner", build: () => [
    R({ left: 0, top: 0, width: 786, height: 200, fill: SKY }),
    R({ left: 0, top: 150, width: 786, height: 50, fill: NAVY }),
    T("GET YOUR POOL", { left: 30, top: 22, fontSize: 40, shadow: sh() }),
    T("SUMMER READY!", { left: 30, top: 70, fontSize: 52, fill: "#fbf7a6", stroke: NAVY, strokeWidth: 1.5, paintFirst: "stroke", shadow: sh() }),
    B("Book your pre-season service today  •  Ph (your number)", { left: 30, top: 164, width: 520, fontWeight: "bold", fontSize: 16 }),
    photo({ left: 560, top: 14, width: 210, height: 130 }),
  ] },
  { key: "banner_product", label: "Footer Banner — Product Promo", preset: "banner", build: () => [
    R({ left: 0, top: 0, width: 786, height: 200, fill: DARK }),
    R({ left: 0, top: 0, width: 14, height: 200, fill: GREEN }),
    photo({ left: 34, top: 20, width: 180, height: 160 }),
    T("MAGNESIUM MINERALS", { left: 240, top: 30, fontSize: 34, fill: GREEN, shadow: sh() }),
    B("Silky-soft, therapeutic water for a better swim. Ask our team in store.", { left: 240, top: 82, width: 330, fontSize: 16 }),
    R({ left: 600, top: 55, width: 160, height: 90, rx: 14, ry: 14, fill: PURPLE }),
    T("$39.95", { left: 618, top: 78, fontSize: 36 }),
  ] },
  { key: "offer_price", label: "Special Offer — Product & Price", preset: "offer", build: () => [
    R({ left: 0, top: 0, width: 260, height: 190, fill: "#ffffff" }),
    photo({ left: 10, top: 10, width: 120, height: 170, stroke: SKY, fill: "rgba(33,166,236,0.08)" }),
    T("Robotic", { left: 140, top: 30, fontSize: 22, fill: DARK, fontWeight: 700 }),
    T("Cleaners from", { left: 140, top: 58, fontSize: 15, fill: DARK, fontWeight: 400 }),
    T("$699", { left: 140, top: 92, fontSize: 40, fill: PURPLE }),
  ] },
  { key: "offer_burst", label: "Special Offer — Sale Burst", preset: "offer", build: () => [
    R({ left: 0, top: 0, width: 260, height: 190, fill: "#ffffff" }),
    new Circle({ left: 120, top: 8, radius: 66, fill: "#e3171b", strokeWidth: 0, shadow: sh() }),
    T("SALE", { left: 146, top: 36, fontSize: 30 }),
    T("20% OFF", { left: 140, top: 76, fontSize: 20, fill: "#fbf7a6" }),
    photo({ left: 10, top: 20, width: 110, height: 150, stroke: "#e3171b", fill: "rgba(227,23,27,0.06)" }),
    B("Spa filters this month", { left: 120, top: 150, width: 140, fontSize: 13, fill: DARK, fontWeight: "bold", textAlign: "center" }),
  ] },
  { key: "email_header", label: "Email Header — Glamour", preset: "email", build: () => [
    R({ left: 0, top: 0, width: 600, height: 200, fill: NAVY }),
    R({ left: 0, top: 170, width: 600, height: 30, fill: SKY }),
    photo({ left: 20, top: 20, width: 150, height: 130 }),
    T("GLAMOUR POOLS & SPAS", { left: 190, top: 50, fontSize: 28 }),
    B("Your local pool & spa water experts", { left: 190, top: 96, width: 380, fontSize: 16 }),
    B("glamourpoolsandspas.com.au", { left: 0, top: 176, width: 600, fontSize: 13, fontWeight: "bold", textAlign: "center" }),
  ] },
  { key: "newsletter", label: "Email Newsletter — Monthly News", preset: "newsletter", build: () => [
    R({ left: 0, top: 0, width: 600, height: 1500, fill: "#f4f7fa" }),
    R({ left: 0, top: 0, width: 600, height: 170, fill: NAVY }),
    T("POOL & SPA NEWS", { left: 30, top: 50, fontSize: 40 }),
    B("This month at Glamour Pools and Spas", { left: 30, top: 108, width: 540, fontSize: 18 }),
    photo({ left: 30, top: 200, width: 540, height: 300, stroke: SKY, fill: "rgba(33,166,236,0.08)" }),
    T("Headline story", { left: 30, top: 525, fontSize: 28, fill: NAVY }),
    B("Write your main story here. Tell clients about a new product, a seasonal tip or an in-store event.", { left: 30, top: 570, width: 540, fontSize: 16, fill: "#333333" }),
    photo({ left: 30, top: 680, width: 255, height: 220, stroke: GREEN, fill: "rgba(139,195,74,0.1)" }),
    photo({ left: 315, top: 680, width: 255, height: 220, stroke: GREEN, fill: "rgba(139,195,74,0.1)" }),
    T("Product 1", { left: 30, top: 915, fontSize: 20, fill: NAVY }), T("Product 2", { left: 315, top: 915, fontSize: 20, fill: NAVY }),
    T("$00.00", { left: 30, top: 948, fontSize: 24, fill: PURPLE }), T("$00.00", { left: 315, top: 948, fontSize: 24, fill: PURPLE }),
    R({ left: 30, top: 1040, width: 540, height: 160, rx: 16, ry: 16, fill: GREEN }),
    T("FREE WATER TESTING", { left: 60, top: 1080, fontSize: 30, fill: DARK }),
    B("Bring in a sample any time — results in minutes.", { left: 60, top: 1130, width: 480, fontSize: 16, fill: DARK }),
    R({ left: 0, top: 1380, width: 600, height: 120, fill: DARK }),
    B("Glamour Pools and Spas  •  Ph (your number)  •  glamourpoolsandspas.com.au", { left: 0, top: 1428, width: 600, fontSize: 14, textAlign: "center" }),
  ] },
];
